module.exports = __webpack_public_path__ + "static/img/yizhanshijiejuefangan.9aeaf4be.png";